import lazyWithRetry from '../Util/lazyWithRetry';

const Home = lazyWithRetry(() =>
  import(/* webpackChunkName: "route-Home" */ '../Screens/UserScreen/Home'),
);
const Dashboard = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-Dashboard" */ './../Screens/AdminScreen/Dashboard'
  ),
);
const Notfound = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-Notfound" */ '../Screens/AdminScreen/ErrorPages/notFound'
  ),
);
const NotAuthorized = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-NotAuthorized" */ '../Screens/AdminScreen/ErrorPages/notAuthrized'
  ),
);
const SignInScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SignInScreen" */ '../Screens/AdminScreen/Auth/SignIn'
  ),
);
const SignUpScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SignUpScreen" */ './../Screens/AdminScreen/Auth/SignUp'
  ),
);
const JobFeeScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-JobFeeScreen" */ '../Screens/AdminScreen/JobFees'
  ),
);
const JobFeesFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-JobFeesFormScreen" */ '../Screens/AdminScreen/JobFees/JobFeesForm'
  ),
);
const AdFeesScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AdFeesScreen" */ '../Screens/AdminScreen/AdFees'
  ),
);
const AdFeesFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AdFeesFormScreen" */ '../Screens/AdminScreen/AdFees/AdFeesForm'
  ),
);
const ChapterScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-ChapterScreen" */ '../Screens/AdminScreen/Chapters'
  ),
);
const AddChapterScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AddChapterScreen" */ '../Screens/AdminScreen/Chapters/AddChapter'
  ),
);
const AdsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AdsScreen" */ '../Screens/AdminScreen/Ads'
  ),
);
const AdsFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AdsFormScreen" */ '../Screens/AdminScreen/Ads/AdsForm'
  ),
);
const UserScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-UserScreen" */ '../Screens/AdminScreen/Users'
  ),
);
const UserFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-UserFormScreen" */ '../Screens/AdminScreen/Users/UserForm'
  ),
);
const JobsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-JobsScreen" */ '../Screens/AdminScreen/Jobs'
  ),
);
const JobsFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-JobsFormScreen" */ '../Screens/AdminScreen/Jobs/JobsForm'
  ),
);
const SponsorScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SponsorScreen" */ '../Screens/AdminScreen/Sponsors'
  ),
);
const SponsorsFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SponsorsFormScreen" */ '../Screens/AdminScreen/Sponsors/SponsorsForm'
  ),
);
const KeywordScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-KeywordScreen" */ '../Screens/AdminScreen/Keywords'
  ),
);
const KeywordFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-KeywordFormScreen" */ '../Screens/AdminScreen/Keywords/KeywordsForm'
  ),
);
const EventTypesScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventTypesScreen" */ '../Screens/AdminScreen/EventTypes'
  ),
);
const EventTypesFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventTypesFormScreen" */ '../Screens/AdminScreen/EventTypes/EventTypesForm'
  ),
);
const SpeakersScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SpeakersScreen" */ '../Screens/AdminScreen/Speakers'
  ),
);
const SpeakersFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SpeakersFormScreen" */ '../Screens/AdminScreen/Speakers/SpeakersForm'
  ),
);
const CompaniesScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-CompaniesScreen" */ '../Screens/AdminScreen/Companies'
  ),
);
const CompaniesFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-CompaniesFormScreen" */ '../Screens/AdminScreen/Companies/CompaniesForm'
  ),
);
const CouponCodesScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-CouponCodesScreen" */ '../Screens/AdminScreen/CouponCodes'
  ),
);
const CouponCodesFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-CouponCodesFormScreen" */ '../Screens/AdminScreen/CouponCodes/CouponCodesForm'
  ),
);
const EmailCodeScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EmailCodeScreen" */ '../Screens/AdminScreen/EmailCode'
  ),
);
const EmailCodeFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EmailCodeFormScreen" */ '../Screens/AdminScreen/EmailCode/EmailCodeForm'
  ),
);
const UserJobsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-UserJobsScreen" */ './../Screens/UserScreen/Jobs/index'
  ),
);
const UserAdsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-UserAdsScreen" */ './../Screens/UserScreen/Ads/index'
  ),
);
const JobsViewDetailsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-JobsViewDetailsScreen" */ '../Screens/UserScreen/Jobs/ViewDetails'
  ),
);
const EventOptionGroupsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventOptionGroupsScreen" */ '../Screens/AdminScreen/EventOptionGroups'
  ),
);
const EventOptionGroupsFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventOptionGroupsFormScreen" */ './../Screens/AdminScreen/EventOptionGroups/EventOptionGroupsForm/index'
  ),
);
const EventOptionsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventOptionsScreen" */ '../Screens/AdminScreen/EventOptions'
  ),
);
const EventOptionsFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventOptionsFormScreen" */ './../Screens/AdminScreen/EventOptions/EventOptionsForm/index'
  ),
);
const EventsFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventsFormScreen" */ './../Screens/AdminScreen/Events/EventsForm/index'
  ),
);
const EventsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventsScreen" */ './../Screens/AdminScreen/Events/index'
  ),
);
const ResetSendEmailScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-ResetSendEmailScreen" */ '../Screens/AdminScreen/Auth/ResetPassword/sendEmail'
  ),
);
const ResetUpdatePassScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-ResetUpdatePassScreen" */ './../Screens/AdminScreen/Auth/ResetPassword/updatePassword'
  ),
);
const PbssInScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-PbssInScreen" */ '../Screens/UserScreen/PbssInternational'
  ),
);
const EventDetailsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventDetailsScreen" */ '../Screens/UserScreen/PbssInternational/EventDetails'
  ),
);
const PbssChapterScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-PbssChapterScreen" */ '../Screens/UserScreen/PbssChapter'
  ),
);
const LoginScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-LoginScreen" */ '../Screens/UserScreen/Login'
  ),
);
const RegisterScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-RegisterScreen" */ '../Screens/UserScreen/Register'
  ),
);
const SponsorshipInfoScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SponsorshipInfoScreen" */ '../Screens/UserScreen/SponsorshipInfo'
  ),
);
const VendorShowScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-VendorShowScreen" */ '../Screens/UserScreen/VendorInfo'
  ),
);
const SponsorPolicyScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SponsorPolicyScreen" */ '../Screens/UserScreen/SponsorPolicy'
  ),
);
const AboutUsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AboutUsScreen" */ '../Screens/UserScreen/AboutUs'
  ),
);
const EventTemplateSchedulerScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventTemplateSchedulerScreen" */ '../Screens/AdminScreen/EventTemplateScheduler'
  ),
);
const EventTempFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventTempFormScreen" */ '../Screens/AdminScreen/EventTemplateScheduler/EventTempForm'
  ),
);
const EventTemplateSchedulerPreviewScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventTemplateSchedulerPreviewScreen" */ '../Screens/AdminScreen/EventTemplateScheduler/EventTemplateSchedulerPreview'
  ),
);
const AddAttendeeScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AddAttendeeScreen" */ '../Screens/UserScreen/AddAttendees'
  ),
);
const AttendeesCartScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AttendeesCartScreen" */ '../Screens/UserScreen/AttendeesCart'
  ),
);
const AssetsUploadScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AssetsUploadScreen" */ '../Screens/UserScreen/AssetsUpload'
  ),
);
const EventSponsorScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventSponsorScreen" */ '../Screens/UserScreen/EventSponsor'
  ),
);
const EventSponsorCartScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventSponsorCartScreen" */ '../Screens/UserScreen/EventSponsorCart'
  ),
);
const AddVendorRepsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AddVendorRepsScreen" */ '../Screens/UserScreen/AddVendorReps'
  ),
);
const ApprovedJobsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-ApprovedJobsScreen" */ '../Screens/UserScreen/Jobs/ApprovedJobs'
  ),
);
const ApprovedAdsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-ApprovedAdsScreen" */ './../Screens/UserScreen/Ads/ApprovedAds/index'
  ),
);
const ContactUsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-ContactUsScreen" */ '../Screens/UserScreen/ContactUS'
  ),
);
const EventRegistrationScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventRegistrationScreen" */ '../Screens/AdminScreen/EventsRegistration'
  ),
);
const MyEventScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-MyEventScreen" */ '../Screens/UserScreen/MyEvent'
  ),
);
const UserUpdateProfileScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-UserUpdateProfileScreen" */ '../Screens/UserScreen/UserUpdateProfile'
  ),
);
const EmailToMembersScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EmailToMembersScreen" */ '../Screens/AdminScreen/EmailToMember'
  ),
);
const EventRefundScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventRefundScreen" */ './../Screens/AdminScreen/EventRefund/index'
  ),
);
const AllRefundScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AllRefundScreen" */ '../Screens/AdminScreen/AllRefund'
  ),
);
const RegistrationHistoryScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-RegistrationHistoryScreen" */ '../Screens/AdminScreen/RegistrationHistory'
  ),
);
const SponsorshipOptionScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SponsorshipOptionScreen" */ '../Screens/UserScreen/SponsorshipOption'
  ),
);
const SponsorPerkForm = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SponsorPerkForm" */ './../Components/UserComponents/SponsorPerkForm/index'
  ),
);
const AdsCartScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AdsCartScreen" */ '../Screens/UserScreen/Ads/AdsCart'
  ),
);
const PaymentHistoryScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-PaymentHistoryScreen" */ '../Screens/UserScreen/PaymentHistory'
  ),
);
const PaymentCheckoutScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-PaymentCheckoutScreen" */ '../Screens/UserScreen/PaymentCheckoutForm'
  ),
);
const SpecialPaymentScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SpecialPaymentScreen" */ '../Screens/UserScreen/SpecialPaymentScreen'
  ),
);
const JobsCartScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-JobsCartScreen" */ './../Screens/UserScreen/Jobs/JobsCart/index'
  ),
);
const UnsubscribeScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-UnsubscribeScreen" */ '../Screens/UserScreen/Unsubscribe'
  ),
);
const FaqScreen = lazyWithRetry(() =>
  import(/* webpackChunkName: "route-FaqScreen" */ '../Screens/UserScreen/Faq'),
);
const StemOutReachScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-StemOutReachScreen" */ '../Screens/UserScreen/StemOutreach'
  ),
);
const IndustryOutReachScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-IndustryOutReachScreen" */ '../Screens/UserScreen/IndustryOutreach'
  ),
);
const OtherPartnersScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-OtherPartnersScreen" */ '../Screens/UserScreen/OtherPartners'
  ),
);
const EventTypesStaticScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EventTypesStaticScreen" */ '../Screens/UserScreen/EventTypesStaticScreen/EventTypesStaticScreen'
  ),
);
const SponsorInfoDetailsScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-SponsorInfoDetailsScreen" */ '../Screens/UserScreen/SponsorInfoDetails'
  ),
);
const AdminSpecialPaymentScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AdminSpecialPaymentScreen" */ '../Screens/AdminScreen/AdminSpecialPaymentScreen'
  ),
);
const AdminSpecialPaymentFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AdminSpecialPaymentFormScreen" */ '../Screens/AdminScreen/AdminSpecialPaymentScreen/AdminSpecialPaymentFormScreen'
  ),
);
const MyEventCartScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-MyEventCartScreen" */ './../Screens/MyEventsCart/index'
  ),
);
const StemScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-StemScreen" */ '../Screens/AdminScreen/Stem'
  ),
);
const IndustryScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-IndustryScreen" */ '../Screens/AdminScreen/Industry'
  ),
);
const PaymentSuccessScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-PaymentSuccessScreen" */ '../Screens/UserScreen/PaymentSuccess'
  ),
);
const PaymentFailedScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-PaymentFailedScreen" */ '../Screens/UserScreen/PaymentFailed'
  ),
);
const ChangePasswordScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-ChangePasswordScreen" */ '../Screens/UserScreen/ChangePassword'
  ),
);
const WaitingListScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-WaitingListScreen" */ '../Screens/AdminScreen/Waitinglist'
  ),
);
const CouponUsersTrackScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-CouponUsersTrackScreen" */ '../Screens/AdminScreen/CouponUsersTrack'
  ),
);
const VerifyEmailScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-VerifyEmailScreen" */ '../Screens/UserScreen/Register/VerifyEmail'
  ),
);
const CommitteeMemberFormScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-CommitteeMemberFormScreen" */ '../Screens/AdminScreen/CommitteeMembers/CommitteeMembersForm'
  ),
);
const CommitteeMemberScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-CommitteeMemberScreen" */ './../Screens/AdminScreen/CommitteeMembers/index'
  ),
);
const EditSponsorshipInfoScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-EditSponsorshipInfoScreen" */ '../Screens/AdminScreen/Chapters/EditSponsorshipInfo'
  ),
);
const PbssInternationalScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-PbssInternationalScreen" */ '../Screens/AdminScreen/PbssInternational'
  ),
);
const CareerMentorshipAdminScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-CareerMentorshipAdminScreen" */ './../Screens/AdminScreen/CareerMentorship/index'
  ),
);
const CareerMentorshipScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-CareerMentorshipScreen" */ './../Screens/UserScreen/CareerMentorship/index'
  ),
);
const AllEmailSchedulerScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-AllEmailSchedulerScreen" */ '../Screens/AdminScreen/AllEmailScheduler'
  ),
);
const PbssFilesScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-PbssFilesScreen" */ '../Screens/AdminScreen/PbssFiles'
  ),
);
const PbssFilesAddScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "route-PbssFilesAddScreen" */ '../Screens/AdminScreen/PbssFiles/PbssFilesAddScreen'
  ),
);
export const RouteConfig = [
  {
    path: 'admin/dashboard',
    element: <Dashboard />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/signin',
    element: <SignInScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/resetPassword',
    element: <ResetSendEmailScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/updatePassword',
    element: <ResetUpdatePassScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/signup',
    element: <SignUpScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/notAuthorized',
    element: <NotAuthorized />,
    isProtectedRoute: false,
    allowedRoles: [],
  },
  {
    path: '/admin/forbidden',
    element: <NotAuthorized usedForAdmin />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [],
  },
  {
    path: '/updateProfile',
    element: <UserUpdateProfileScreen />,
    allowedLayout: 'main',
    isProtectedRoute: true,
    allowedRoles: [],
  },
  {
    path: '/admin/jobfees',
    element: <JobFeeScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/jobfees/add',
    element: <JobFeesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/jobfees/update/:id',
    element: <JobFeesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/adfees',
    element: <AdFeesScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/adfees/add',
    element: <AdFeesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/adfees/update/:id',
    element: <AdFeesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/chapters',
    element: <ChapterScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/chapters/add',
    element: <AddChapterScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/chapters/update/:id',
    element: <AddChapterScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/sponsorshipInfo/:chapterId',
    element: <EditSponsorshipInfoScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/ads',
    element: <AdsScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/ads/add',
    element: <AdsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/ads/update/:id',
    element: <AdsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/memberAttendees',
    element: <UserScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/memberAttendees/add',
    element: <UserFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/emailToMembers',
    element: <EmailToMembersScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/allEmailScheduler',
    element: <AllEmailSchedulerScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/specialPayment',
    element: <AdminSpecialPaymentScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/specialPayment/add',
    element: <AdminSpecialPaymentFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/memberAttendees/update/:id',
    element: <UserFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/jobs',
    element: <JobsScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/jobs/add',
    element: <JobsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/jobs/update/:id',
    element: <JobsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/sponsors',
    element: <SponsorScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/sponsors/add',
    element: <SponsorsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/sponsors/update/:id',
    element: <SponsorsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    // path: '/admin/keywords',
    path: '/admin/interests',
    element: <KeywordScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    // path: '/admin/keywords/add',
    path: '/admin/interests/add',
    element: <KeywordFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    // path: '/admin/keywords/update/:id',
    path: '/admin/interests/update/:id',
    element: <KeywordFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventTypes',
    element: <EventTypesScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventTypes/add',
    element: <EventTypesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventTypes/update/:id',
    element: <EventTypesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/speakers/update/:id',
    element: <SpeakersFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/companies',
    element: <CompaniesScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/companies/add',
    element: <CompaniesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/companies/update/:id',
    element: <CompaniesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/couponCodes',
    element: <CouponCodesScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/couponCodes/add',
    element: <CouponCodesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/couponCodes/update/:id',
    element: <CouponCodesFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/couponCodes/users/:id',
    element: <CouponUsersTrackScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/emailTemplates',
    element: <EmailCodeScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/emailTemplates/add',
    element: <EmailCodeFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/emailTemplates/update/:id',
    element: <EmailCodeFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventOptionGroups',
    element: <EventOptionGroupsScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventOptionGroups/add',
    element: <EventOptionGroupsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventOptionGroups/update/:id',
    element: <EventOptionGroupsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventOptions/:id',
    element: <EventOptionsScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventOptions/add/:eventId',
    element: <EventOptionsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventOptions/update/:id',
    element: <EventOptionsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/events',
    element: <EventsScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/events/add',
    element: <EventsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/events/update/:id',
    element: <EventsFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventRegistration/:id',
    element: <EventRegistrationScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventRefund/:id',
    element: <EventRefundScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/allRefund',
    element: <AllRefundScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/registrationHistory',
    element: <RegistrationHistoryScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventEmailTemplatesScheduler',
    element: <EventTemplateSchedulerScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventEmailTemplate/preview/:eventId/:schedulerId',
    element: <EventTemplateSchedulerPreviewScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventEmailTemplatesScheduler/:id',
    element: <EventTemplateSchedulerScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventEmailTemplatesScheduler/add/:id',
    element: <EventTempFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/eventEmailTemplatesScheduler/update/:id/:eventID/:action',
    element: <EventTempFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/jobs',
    element: <UserJobsScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/ads',
    element: <UserAdsScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/ads/cart/:id',
    element: <AdsCartScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/jobs/cart/:id',
    element: <JobsCartScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/jobs/:id',
    element: <JobsViewDetailsScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/jobs/approved',
    element: <ApprovedJobsScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/ads/approved',
    element: <ApprovedAdsScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/',
    element: <PbssInScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/pbssInternational',
    element: <PbssInScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/eventDetails/:id',
    element: <EventDetailsScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/chapter/:chapterName',
    element: <PbssChapterScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/chapter/:chapterName/:language',
    element: <PbssChapterScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },

  {
    path: '/login',
    element: <LoginScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/register',
    element: <RegisterScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/myEvents/:registrationType',
    element: <MyEventScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/myEvents',
    element: <MyEventScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },

  {
    path: '/myCart',
    element: <MyEventCartScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/myCart/:registrationType',
    element: <MyEventCartScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },

  {
    path: '/sponsorPerkForm',
    element: <SponsorPerkForm />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/sponsorAssetsUpload',
    element: <AssetsUploadScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/addAttendees/:id',
    element: <AddAttendeeScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/attendeesCart/:id',
    element: <AttendeesCartScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/sponsorshipOption/:id',
    element: <SponsorshipOptionScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/eventSponsor/:id/:optionId',
    element: <EventSponsorScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/eventSponsorCart/:id/:optionId',
    element: <EventSponsorCartScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/attendeesCart/:id/:transactionId',
    element: <AttendeesCartScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/addVendorReps/:eventId/:sponsorRegistrationId',
    element: <AddVendorRepsScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/eventSponsorCart/:id/:optionId/:transactionId',
    element: <EventSponsorCartScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/eventMajorSponsor',
    element: <SponsorshipInfoScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/eventVendorShow',
    element: <VendorShowScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/eventSponsorPolicy',
    element: <SponsorPolicyScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/aboutUs',
    element: <AboutUsScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/contactUs',
    element: <ContactUsScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/faq',
    element: <FaqScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/stemOutreach',
    element: <StemOutReachScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/industryOutreach',
    element: <IndustryOutReachScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/careerMentorship',
    element: <CareerMentorshipScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/Partners',
    element: <OtherPartnersScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/payment/:attendeeType/:id/:optionId',
    element: <PaymentCheckoutScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/payment/:attendeeType/:id',
    element: <PaymentCheckoutScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/specialPayment',
    element: <SpecialPaymentScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/paymentHistory',
    element: <PaymentHistoryScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [
      'admin',
      'user',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/unsubscribe',
    element: <UnsubscribeScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/verifyEmail',
    element: <VerifyEmailScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: 'eventType/:eventTypeName',
    element: <EventTypesStaticScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/sponsorshipInfo',
    element: <SponsorInfoDetailsScreen />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/admin/stem',
    element: <StemScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/industry',
    element: <IndustryScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/careerMentorship',
    element: <CareerMentorshipAdminScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/committeeMember',
    element: <CommitteeMemberScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/committeeMember/add',
    element: <CommitteeMemberFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/committeeMember/update/:id',
    element: <CommitteeMemberFormScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/waitingList/:id',
    element: <WaitingListScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/paymentSuccess/:action/:registrationType',
    element: <PaymentSuccessScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/paymentSuccess/:action',
    element: <PaymentSuccessScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/paymentFailed/:action',
    element: <PaymentFailedScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/changePassword',
    element: <ChangePasswordScreen />,
    isProtectedRoute: true,
    allowedLayout: 'main',
    allowedRoles: [],
  },
  {
    path: '/admin/pbssInternational',
    element: <PbssInternationalScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/pbssFiles',
    element: <PbssFilesScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '/admin/pbssFiles/add',
    element: <PbssFilesAddScreen />,
    isProtectedRoute: true,
    allowedLayout: 'admin',
    allowedRoles: [
      'admin',
      'super_admin',
      'event_manager_admin',
      'event_registration_admin',
    ],
  },
  {
    path: '*',
    element: <Notfound />,
    isProtectedRoute: false,
    allowedLayout: 'main',
    allowedRoles: [],
  },
];
